import React, { Component } from 'react'
import classNames from "classnames"
import { Icon, Modal, Popconfirm, Button } from 'antd'
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import OrderMockUp from "./data/OrderMockUp"
import ListItemsQCnotMask from "./ListItemsQCnotMask"
import MarkItemError from "./MarkItemError"
import SewingRepairModal from './SewingRepairModal'
import QchtDescriptionBox from './QchtDescriptionBox'
import { listPartner, getListSku } from "../../../../services/api/3dApi"
import MarkPackagedPageSpecifications from '../../../orders-packing/components/MarkPackagedPageSpecifications'
import { resolveBrandDescriptions } from '../../helpers/brandDescription'

class ItemQCnotMask extends Component {
    constructor(props) {
        super(props)

        this.state = {
            visible: false,
            width: 0,
            height: 0,
            isOpen: false,
            showSewingRepair: false,
            isPartnerGlobal: false,
            partnerQM: {},
            isPartnerQM: false,
            showImage: '',
            isOpenPreview: false,
        }

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    componentDidMount() {
        (async () => {
            this.updateWindowDimensions()
            await this._fetchPartners()
            this._fetchSku()
        })()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight })
    }

    _showModal = () => {
        this.setState({
            visible: true,
        })
    }

    _hideModal = () => {
        this.setState({
            visible: false,
        })
    }

    _fetchPartners = async () => {
        const { item } = { ...this.props }
        let is3d = item
        if (item.hasOwnProperty('tool3d_order')) {
            is3d = item.tool3d_order
        }
        const partnerCheck = !!is3d.hasOwnProperty('batch_item') && !!is3d.batch_item.batch && is3d.batch_item.batch.partner

        try {
            const { data: response } = await listPartner()

            const { success, error, data } = response

            if (!success) {
                this.setState({
                    error
                })

                return
            }
            const partnerItem = data.partners.find(partner => partner._id === partnerCheck)
            const partnerQM = data.partners.find(partner => partner.name === 'QUANG MINH' && partner.code === 'HN89')
            this.setState({
                error: '',
                isPartnerGlobal: (partnerItem.code === "AJL4") ? true : false,
                partnerQM: partnerQM,
            })
        } catch (e) {
            this.setState({})
        }
    }

    _fetchSku = async () => {
        const { item } = { ...this.props }
        const { partnerQM = {} } = this.state

        if(!Object.keys(partnerQM).length) return

        try {
            const payload = {
                limit: 10000,
                partner: [partnerQM._id]
            }
            const { data: res } = await getListSku(payload)
            const { data, success, message } = { ...res }
            if (!success) {
                console.log(message)
                return
            }
            const listSku = data.items.map(i => i.sku)
            this.setState({
                isPartnerQM: !!listSku && listSku.includes(item.type) ? true : false
            })
        } catch (error) {
            console.log(error)
        }
    }

    _handleChangeChecked = () => {
        const { item, updateOrdersSelected } = this.props

        if (item.hasOwnProperty('tool3d_order')) {
            const { tool3d_order } = item

            if (!item.can_qc_completed) return

            const { _id: orderID } = tool3d_order

            const isChecked = this._detectChecked()

            updateOrdersSelected(orderID, !isChecked)
        }
    }

    _detectChecked = () => {
        const { item, arrChecked } = this.props

        if (item.hasOwnProperty('tool3d_order')) {
            const { tool3d_order } = item
            const { _id: orderID } = tool3d_order

            return arrChecked.includes(orderID)
        }
    }

    _isOpenModal = () => {
        document.body.classList.add('CustomSelect')

        this.setState({
            isOpen: true
        })
    }

    _isOpenSewingRepairModal = () => {
        document.body.classList.add('CustomSelect')

        this.setState({
            showSewingRepair: true
        })
    }

    _isCloseModal = () => {
        document.body.classList.remove('CustomSelect')

        this.setState({
            isOpen: false
        })
    }

    _isCloseSewingRepairModal = () => {
        document.body.classList.remove('CustomSelect')

        this.setState({
            showSewingRepair: false
        })
    }

    _handleChangeImage = (url = '', open = false) => {
        this.setState(preState => ({
            ...preState,
            showImage: url,
            isOpenPreview: open
        }))
    }

    render() {
        const { visible, height, isOpen, showSewingRepair, isPartnerGlobal, isPartnerQM, showImage, isOpenPreview } = this.state
        const {
            item,
            defaultChecked,
            outItems,
            cancelQC,
            typeQC,
            allSelected,
            toggleSelectAll,
            loading,
            loadingQC1ST,
            selectedItem,
            textLoading,
            name,
            submitQC,
            submitQC1ST,
            inputValue,
            totalItems,
            allItems,
            reset,
            relatedSkuWithInputBarcode,
            refocusInput,
            sku,
            skuSizes,
            orderItem,
            isPhotoRequest,
        } = this.props

        const isChecked = this._detectChecked()
        const isDefaultChecked = (defaultChecked !== undefined && defaultChecked.length > 0) ? defaultChecked.includes(item._id) : false
        let is3d = item

        if (item.hasOwnProperty('tool3d_order')) {
            is3d = item.tool3d_order
        }

        const showSafeZone = (category, dimension) => {
            if (!!is3d.safezone_image) {
                return <img style={{ height: `${height - 210}px` }} src={is3d.safezone_image} alt="SafeZone"
                    className="Safezone" />
            }
        }

        const showSafeZone2 = (category, dimension) => {
            if (!!is3d.safezone_image) {
                return <img src={is3d.safezone_image} alt="SafeZone"
                    className="Safezone" />
            }
        }

        const { mock_up_front, mock_up_back, type, size, batch_item, tags } = is3d
        const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
        const isCutoffTag = Array.isArray(tags) && tags.includes('cutoff')
        const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
        const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
        const hasSpecialTag = !!isFastProductionTag || (!!isCutoffTag || !!isCutOffNoel || !!isCutOffNewYear)
        const { mark_as_qc_1st, batch, product_type } = { ...batch_item }
        const { brand_name = '', brand_tags = {} } = item
        const { branding = [], packaging = [] } = { ...brand_tags }
        const { description, brands_description_packaged: brandsDescriptionPackaged = [] } = { ...relatedSkuWithInputBarcode }
        const listDes = !!description && description.split('\n')
        const skuNotQC1ST = [
            'MASKCC_3D', 'MASKCCNUT_3D', 'MASK_3D', 'MASK_HYPER_3D', 'MASK_SQUARE_3D', 'MASK_PS_3D', 'MASK_PQ_3D', 'MASKCC_V2_3D', 'MASK_NEP_3D',
            'MASK_NEP_NUT_3D', 'MASK_NUT_3D', 'FILTER', 'STICKER', 'BRAND_KIT', 'UV_LED', 'UV_LED_MICA', 'ENGRAVED_LED',
            'UV_HEART_HOLDER', 'UV_HOLDER', 'ORNAMENT_3D', 'CUT_ORNAMENT_3D', 'ENGRAVED_ORNAMENT_3D', '1_MDF_ORNAMENT_3D', '2_MDF_ORNAMENT_3D',
            'MDF_CUSTOM_ORNAMENT_3D', 'CUSTOM_ORNAMENT_3D', 'CUSTOM_ORNAMENT_V2_3D', 'CUSTOM_CAR_ORNAMENT', 'PLASTIC_CAR_ORNAMENT', '1_PLASTIC_CAR_ORNAMENT',
            'PLASTIC_WINDOW_ORNAMENT', '1L_WOOD_ORNAMENT', '2L_WOOD_ORNAMENT', 'WOOD_ACRYLIC_ORNAMENT', '1_WHITE_PLASTIC_ORNAMENT', '1_WHITE_PLASTIC_CAR_ORNAMENT',
            '1L_WOOD_ORNAMENT_UID', 'MICA_ORNAMENT_UID', 'WOOD_KEYCHAIN_3D', 'MICA_KEYCHAIN_V2_3D', 'MICA_KEYCHAIN_3D', 'PET_KEYCHAIN_3D', 'MICA_PIN',
            'MASKCC_01', 'MASK_01', 'MASK_SQUARE_01', 'MASKCC_V2_01', 'STICKER', 'BRAND_KIT', 'CUT_ORN_0203CU', '1L_KEY_0103MT', '2L_KEY_0102MT', '1W_ORN_0103MT',
            '1L_ORN_0203TM', '2L_ORN_0203TM', 'CUSTOM_ORN_0103MTM', 'HEART_HOLDER_0250TM', 'HOLDER_0250TM', 'UV_LED_0103MT', '2L_REG_ORN_12MT',
        ]
        const disabledBtnQC = loading || selectedItem.length === 0 ||
            (isPartnerQM && !!is3d.tags && is3d.tags.includes('priority-store') && !mark_as_qc_1st && !skuNotQC1ST.includes(product_type))
        const disabledBtnQC1ST = loadingQC1ST || selectedItem.length === 0 ||
            (isPartnerQM && !!is3d.tags && is3d.tags.includes('priority-store') && !!mark_as_qc_1st && !skuNotQC1ST.includes(product_type))

        const isMadeInVN = Array.isArray(tags) && tags.includes('made_vn')
        const brandDescriptions = resolveBrandDescriptions(brandsDescriptionPackaged, brand_name)

        return (
            <div className="wrapItem ItemQCnotMask">
                <div
                    className={classNames((isChecked || isDefaultChecked) ? 'position-relative itemChecked' : 'position-relative')}>
                    <div className="infoContent col-5 px-0 d-flex justify-content-between flex-wrap w-100">
                        <div className="leftContent">
                            <div className="d-flex BasicInfo infoItemNotMask flex-wrap align-items-center ">
                                <div className="Type mr-2"><strong>{item.type}</strong></div>
                                {
                                    !!is3d.hasOwnProperty('batch_item') && !!is3d.batch_item.batch &&
                                    <div className="badge badge-success badge-pill mr-2 Batch"><Link
                                        to={`/batches/${is3d.batch_item.batch._id}`}>{is3d.batch_item.batch.name}</Link>
                                    </div>
                                }
                                <div className="badge badge-success badge-pill mr-2">
                                    {!!is3d.hasOwnProperty('batch_item') && !!is3d.batch_item.batch && is3d.batch_item.status}
                                </div>
                                <div className="badge badge-secondary badge-pill mr-2">{is3d.size}</div>
                                <div className="badge badge-secondary badge-pill mr-2">{is3d.item_number}</div>
                                {
                                    !!brand_name && <div className="Brand mr-2 badge badge-danger badge-pill py-1 px-2">
                                        {brand_name}
                                    </div>
                                }
                                {
                                    !!branding.length && <div className="Brand mr-2 border border-danger text-danger py-1 px-2 my-1">
                                        {
                                            branding.map((item, index) => (
                                                index ? `, ${item.name}` : item.name
                                            ))
                                        }
                                    </div>
                                }

                                {
                                    isPhotoRequest &&
                                    <div className="badge badge-pill mr-2 font-weight-bold"  style={{ backgroundColor: '#b700ff', color: 'white' }}>
                                        CHỤP ẢNH
                                    </div>
                                }
                            </div>
                            {
                                totalItems > 0 && (
                                    <div className="total mb-3">
                                        <strong>{typeQC ? (allItems.length) : 1}</strong> đơn
                                        cần đánh dấu
                                    </div>
                                )
                            }
                        </div>
                        <div className="rightContent">
                            {isMadeInVN &&
                                <span className='mb-2 tagVN'>Made in VN</span>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5">
                            <OrderMockUp mockUpFront={mock_up_front} mockUpBack={mock_up_back} orderId={item._id} />

                            <div className="foot d-flex align-items-center justify-content-between w-100 mb-1">
                                <div>
                                    <button type="button" onClick={cancelQC} className="btn btn-outline-secondary">
                                        Hủy
                                    </button>
                                    <button type="button" className="ml-2 btn btn-danger"
                                        onClick={this._isOpenModal}>
                                        Đánh dấu lỗi
                                    </button>
                                </div>

                                <div className="d-flex align-items-center justify-content-end">

                                    {typeQC &&
                                        <div className='d-flex align-items-center'>
                                            <input className="mr-2" checked={allSelected} readOnly id="checkAll"
                                                type="checkbox"
                                                onClick={toggleSelectAll} />
                                            <label htmlFor="checkAll">Chọn tất cả</label>
                                        </div>
                                    }
                                    {isPartnerQM && !!is3d.tags && is3d.tags.includes('priority-store') && !skuNotQC1ST.includes(product_type) &&
                                        ((loadingQC1ST || selectedItem.length === 0) ?
                                            <Button
                                                type="primary"
                                                disabled={false}
                                                className="ml-3 CustomPopConfirm">
                                                {
                                                    loadingQC1ST ? textLoading : 'Đánh dấu QC lần 1'
                                                }
                                            </Button> :
                                            <Popconfirm placement="top" className='CustomPopConfirm'
                                                icon={<Icon type="question-circle" />}
                                                title={`Bạn chắc chắn muốn Đánh dấu QC lần 1 cho sản phẩm này?`}
                                                onConfirm={submitQC1ST} okText={'Đánh dấu QC lần 1'}
                                                cancelText="Hủy" disabled={disabledBtnQC1ST}>
                                                <Button type="primary" size='large' disabled={disabledBtnQC1ST}
                                                    className="ml-3">
                                                    {
                                                        loadingQC1ST ? textLoading : 'Đánh dấu QC lần 1'
                                                    }
                                                </Button>
                                            </Popconfirm>)
                                    }
                                    {
                                        (loading || selectedItem.length === 0) ?
                                            <Button
                                                type="button"
                                                disabled={disabledBtnQC}
                                                className="ml-3 CustomPopConfirm">
                                                {
                                                    loading ? textLoading : name
                                                }
                                            </Button> :
                                            <Popconfirm placement="top" className='CustomPopConfirm'
                                                icon={<Icon type="question-circle" />}
                                                title={`Bạn chắc chắn muốn ${name} cho sản phẩm này?`}
                                                onConfirm={submitQC} okText={name}
                                                cancelText="Hủy" disabled={disabledBtnQC}>
                                                <Button
                                                    type="button"
                                                    disabled={disabledBtnQC}
                                                    className="ml-3">
                                                    {
                                                        loading ? textLoading : name
                                                    }
                                                </Button>
                                            </Popconfirm>
                                    }
                                </div>
                            </div>
                            {
                                !!Object.keys(orderItem) && Object.values(skuSizes).some(i => !!i.package_description) &&
                                <MarkPackagedPageSpecifications
                                    sku={sku}
                                    skuSizes={skuSizes}
                                    processingOrder={orderItem}
                                />
                            }
                            {!brand_name && !!listDes &&
                                <div className="foot d-flex align-items-center justify-content-between w-100">
                                    {!brand_name && (listDes.length > 1 ?
                                        <div style={{ background: 'rgb(233 236 239)', color: 'black' }}
                                            className='w-100 border'>
                                            <ul className='mt-3 pr-3' style={{ fontWeight: '400', fontSize: '1rem' }}>
                                                {listDes.length && listDes.map(i => (<li>{i}</li>))}
                                            </ul>
                                        </div> :
                                        (!!listDes &&
                                            <div style={{ background: 'rgb(233 236 239)', color: 'black' }}
                                                className='w-100 border'>
                                                <ul className='mt-3 px-4' style={{ fontWeight: '400', fontSize: '1rem' }}>
                                                    {listDes}
                                                </ul>
                                            </div>
                                        )
                                    )}
                                </div>
                            }
                            <QchtDescriptionBox descriptions={brandDescriptions} onClosePreview={refocusInput} />
                            {
                                (!!branding.length || !!packaging.length) &&
                                <div className='MarkPackagedPageSpecifications mt-2'>
                                    <div className="BoxContent">
                                        <div className="ImageBrand mb-3">
                                            <div className='font-weight-bold h5' style={{ color: 'crimson' }}>Branding</div>
                                            <div className="list-item">
                                                {
                                                    branding.map(item => (
                                                        <div className="BrandItem" key={item._id}>
                                                            <div className='mb-1'>
                                                                {
                                                                    [
                                                                        <span className='font-weight-bold'>{item.name}</span>,
                                                                        <span> (Qty = {item.quantity_per_item || 1})</span>,
                                                                        item.description && <span>: {item.description}</span>
                                                                    ].filter(Boolean)
                                                                }
                                                            </div>
                                                            <div className={item.design ? 'img-item' : 'no-design'}>
                                                                {!!item.design &&
                                                                    <div className='position-relative'>
                                                                        <img src={item.design || ''} alt="preview" loading='lazy' />
                                                                        <div className='Icon position-absolute'>
                                                                            <Icon
                                                                                className='eye-icon'
                                                                                type="eye"
                                                                                onClick={() => this._handleChangeImage(item.design, true)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        <div className="ImageBrand">
                                            <div className='font-weight-bold h5' style={{ color: 'crimson' }}>Packaging</div>
                                            <div className="list-item">
                                                {
                                                    packaging.map(item => (
                                                        <div className="BrandItem" key={item._id}>
                                                            <div className='mb-1'>
                                                                {
                                                                    [
                                                                        <span className='font-weight-bold'>{item.name}</span>,
                                                                        <span> (Qty = {item.quantity_per_item || 1})</span>,
                                                                        item.description && <span>: {item.description}</span>
                                                                    ].filter(Boolean)
                                                                }
                                                            </div>
                                                            <div className={item.design ? 'img-item' : 'no-design'}>
                                                                {!!item.design &&
                                                                    <div className='position-relative'>
                                                                        <img src={item.design || ''} alt="preview" loading='lazy' />
                                                                        <div className='Icon'>
                                                                            <Icon
                                                                                className='eye-icon'
                                                                                type="eye"
                                                                                onClick={() => this._handleChangeImage(item.design, true)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }
                        </div>
                        <div className="col-sm-7">
                            <div className="ImagePreview position-relative" style={{overflow : hasSpecialTag ? 'visible' : 'hidden'}}>
                                <img style={{height: `${height - 210}px`}} src={['GIFTCARD_1800NO'].includes(product_type) ? is3d.mock_up_front : is3d.preview_image || is3d.designFront}
                                    className='previewImage NotOpacity'
                                    alt='preview' />
                                {
                                    showSafeZone(type, size)
                                }
                                <div
                                    className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                    <span className='Icon cursor-pointer mr-2' onClick={this._showModal}><Icon
                                        type='eye' /></span>
                                </div>
                                <Modal visible={visible} closable={false} centered={true} footer={null} width={1200}
                                    onCancel={this._hideModal} className='PrintedFileModal'>
                                    <div className="Previewer">
                                        <img src={['GIFTCARD_1800NO'].includes(product_type) ? is3d.mock_up_front : is3d.preview_image} alt='preview' className='d-block m-auto' />
                                        {
                                            showSafeZone2(type, size)
                                        }
                                    </div>
                                </Modal>
                                <div className="infoImage">
                                    {(isChecked || isDefaultChecked) && (
                                        <div className="checked position-absolute text-primary">
                                            <i className="fa fa-check-circle fa-2x" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ListItems">
                    {
                        outItems.length > 0 && <ListItemsQCnotMask outItems={outItems} />
                    }
                </div>

                <MarkItemError
                    isOpen={isOpen}
                    id={!!is3d && !!is3d.batch_item ? is3d.batch_item._id : ''}
                    inputValue={inputValue}
                    reset={reset}
                    onClose={this._isCloseModal}
                    is3d={is3d}
                    isPartnerGlobal={isPartnerGlobal}
                />
                <SewingRepairModal
                    isOpen={showSewingRepair}
                    itemId={!!is3d && !!is3d.batch_item ? is3d.batch_item._id : ''}
                    inputValue={inputValue}
                    onClose={this._isCloseSewingRepairModal}
                    reset={reset}
                />
                {
                    !!showImage && isOpenPreview &&
                    <Modal
                        visible={isOpenPreview}
                        onCancel={() => this._handleChangeImage('', false)}
                        closable={false}
                        footer={false}
                        width={"50vw"}
                        height={"75vh"}
                    >
                        <img
                            src={showImage}
                            alt="preview"
                            width={"100%"}
                            style={{ objectFit: 'contain' }}
                        />
                    </Modal>
                }
            </div>
        )
    }
}

ItemQCnotMask.propTypes = {
    item: PropTypes.object.isRequired,
    arrChecked: PropTypes.array,
    updateOrdersSelected: PropTypes.func.isRequired,
}

export default ItemQCnotMask
